import { useQuery } from '@tanstack/react-query';
import { shopsService } from '../services/shops.service';

export function useShop(id: string) {
  return useQuery({
    queryKey: ['shops', id],
    queryFn: () => shopsService.getShop(id),
    enabled: !!id,
  });
}
